import { OptionKey } from '@common-fe/common-fe';

export enum RoleLevel {
  All = 'ALL',
  Global = 'GLOBAL',
  Elevate = 'ELEVATE',
  Partner = 'PARTNER',
}
export const SYNTHETIC_SELF_ID = 'SYNTHETIC_SELF_ID';
export const NO_ACCESS_ROLE_ID = '11';
export const SUPER_USER_ROLE_ID = '3';
export const ADD_CONTACT_ID = '22';
export const EDIT_CONTACT_ID = '23';
export const VIEW_CONTACT_ID = '24';

export const CONTACT_ORDER_IDS = [ADD_CONTACT_ID, EDIT_CONTACT_ID, VIEW_CONTACT_ID];

export enum FieldLevelAccessValue {
  Hide = 'HIDDEN',
  Edit = 'MODIFIABLE',
  View = 'LOCKED',
}

export interface IFieldLevelAccessProperties {
  [key: string]: FieldLevelAccessValue;
}

export interface IFieldLLevelAccess {
  id: string;
  name: string;
  description: string;
  properties: IFieldLevelAccessProperties;
  overridableProperties: IFieldLevelAccessProperties;
}

export interface IRoleBasicProperties {
  id?: string;
  name: string;
  level: RoleLevel;
  organizationId?: string;
  description: string;
  isAllowedToCreateAnotherRole?: boolean;
  fieldLevelAccessId: string;
  rolesIdsAllowedForCreation?: OptionKey[];

  allowedForContactsByRoleId: OptionKey[];
}
export interface IPermissionsSection {
  isCopyRole?: boolean;
  copyRoleId?: string;

  granted?: IPermissionGroup[];
  revoked?: IPermissionGroup[];
}
export interface IRoleSetup extends IRoleBasicProperties, IPermissionsSection {
  permissions: OptionKey[];
}

export interface IPermission {
  id: string;
  key: string;
  name: string;
  description: string;
  group?: number | string;
  groupName?: string;
  isAlwaysOn?: boolean;

  isFirstItemInSpecialGroup?: boolean;
  isLastItemInSpecialGroup?: boolean;
}
export interface IPermissionGroup {
  id: string;
  name: string;
  options: IPermission[];
}

export interface IRawPermissionResponse {
  id: number;
  name: string;
  group_id: number;
  group_name: string;
  display_name: string;
  description: string;
}

export interface Properties {
  [key: string]: string;
}
export interface FieldLevelAccessListItemResponse {
  id: number;
  name: string;
  description: string;
  roles_applied_to: string[];
  overridable_properties: Properties;
  properties: Properties;
}

export enum RolesAndSecurityTabs {
  ROLES = 'Roles',
  FIELD_LEVEL_ACCESS = 'Field Level Access',
}

export interface FieldLevelAccessBasicProperties {
  id: string;
  name: string;
  description: string;
  roles: string[];
}

export interface FieldLevelAccessSetupProperties {
  properties?: IFieldLevelAccessProperties;
  overridableProperties?: IFieldLevelAccessProperties;
}

export interface IPropertiesSection {
  isCopyLevelAccess?: boolean;
  copyLevelAccessId?: string;
}

export interface IFieldLevelAccessSetup
  extends FieldLevelAccessBasicProperties, FieldLevelAccessSetupProperties, IPropertiesSection {}
